import styled from "styled-components";

import { Colors, Spacing, MediaQueries } from "@paclife/plds.tokens";
import { Button } from "@paclife/plds.button";
import Typography from "common/Typography/Typography";
import BaseModal from "common/Modal/BaseModal";

const CancelButton = styled(Button)`
    width: 120px;
`;
const ConfirmButton = styled(Button)`
    width: 120px;
`;

const Content = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const Title = styled(Typography)`
    color: ${Colors.primary};
    margin: ${Spacing[16]} 0 ${Spacing[24]};
    // tablet and mobile
    @media (max-width: ${MediaQueries.lg}) {
        margin: ${Spacing[8]} 0;
    }
`;

const SubTitle = styled(Typography)`
    margin-bottom: ${Spacing[16]};
`;

const LogoutModal = ({ closeModal }) => {
    const handleLogout = () => {
        document.location.href = "/authn/logout";
    };

    return (
        <BaseModal
            size="default"
            secondaryButton={
                <CancelButton
                    variant="secondaryNeutral"
                    onClick={closeModal}
                    data-track="analytics"
                    data-bname="logout-modal-cancel"
                >
                    Cancel
                </CancelButton>
            }
            primaryButton={
                <ConfirmButton
                    onClick={handleLogout}
                    data-track="analytics"
                    data-bname="logout-modal-logout"
                >
                    Log out
                </ConfirmButton>
            }
            closeModal={closeModal}
        >
            <Content>
                <Title variant="h2" display="block" align="center">
                    Log out of your account?
                </Title>
                <SubTitle variant="body" align="center">
                    This action will sign you out of the website. You will need
                    to log back in to access your account.
                </SubTitle>
            </Content>
        </BaseModal>
    );
};

export default LogoutModal;
